// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609040445/js/" + chunkId + "." + {"44":"2d1bc998","225":"128c9d92","481":"f1c20541","486":"dbdce4dd","770":"3e1a2f90"}[chunkId] + ".0.4608656235719808.chunk.js";
};